export const APPLE_SOCIAL = 'apple'
export const FACEBOOK_SOCIAL = 'facebook'
export const LINE_SOCIAL = 'line'

export const DEFAULT_SOCIAL_DISPLAYNAME = (provider: string) => {
  switch (provider) {
    case APPLE_SOCIAL:
      return 'Apple ID'
    case FACEBOOK_SOCIAL:
      return 'Facebook ID'
    case LINE_SOCIAL:
      return 'Line ID'
    default:
      return ''
  }
}
